// Site-wide constants
export const PRAYER_LINE_PHONE_DISPLAY = "1-888-702-4185";
export const PRAYER_LINE_PHONE_TEL = "tel:+18887024185";

export const PRAYER_LINES = [
  { label: "Prayer Line", display: PRAYER_LINE_PHONE_DISPLAY, tel: PRAYER_LINE_PHONE_TEL },
];
